'use client';

import Button, { ButtonVariants } from '@pixum/button';
import styles from './UploadErrorNoUploadReupload.module.css';

interface UploadErrorNoUploadReuploadProps {
  constants: Record<string, string>;
  onDontUpload: () => void;
  onReupload: () => void;
}

export function UploadErrorNoUploadReupload({ constants, onDontUpload, onReupload }: UploadErrorNoUploadReuploadProps) {
  return (
    <div className={styles.uploadErrorNoUploadReupload}>
      <Button variant={ButtonVariants.SECONDARY} onClick={onDontUpload}>
        {constants['i18n_upload_error_dont_upload']}
      </Button>
      <Button onClick={onReupload}>{constants['i18n_upload_new_images']}</Button>
    </div>
  );
}
